import Helmet from 'react-helmet'

type MetaProps = {
  title?: string
}

const Meta = ({ title }: MetaProps) => {
  return (
    <Helmet
      titleTemplate="%s • Clariti"
      defaultTitle="Clariti"
    >

      {
        title
        && <title>{title}</title>
      }

    </Helmet>
  )
}

export default Meta
